import styled from "styled-components";
export const OtherDestinationsInfoStyled = styled.div`
  /* height: 20vh;
  overflow-y: scroll;
  margin-top: 10px;
  border-radius: 8px; */
`;
export const OtherDestinationsInfoCard = styled.div`
  background-color: #48cfad;
  border-radius: 8px;
  padding: 5px 10px;
  margin-top: 10px;
`;
export const DestinationsTitle = styled.div`
  font-size: 16px;
  font-weight: 999;
  color: #fff;
`;
export const ReciverContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px auto;
`;
export const ReciverInput = styled.input`
  border-radius: 8px;
  background-color: #fff;
  height: 4vh;
  width: 48%;
  padding: 10px;
`;
export const IconBox = styled.div`
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  padding: 2px;
  &:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`;
